import { FilterMode } from 'app/src/components/ViewFilters/types';

const defaultMode = FilterMode.Or;

export class ModeFilter {
  public mode: FilterMode;
  public filterType: 'mode' = 'mode';

  constructor(value: FilterMode = defaultMode) {
    this.mode = value;
  }

  filterLength(): number {
    return 1;
  }

  isEmpty(): boolean {
    return false;
  }

  getMode() {
    return this.mode;
  }

  setMode(value: FilterMode) {
    this.mode = value;
  }

  toUrlParams(): {
    [key: string]: string | null;
  } {
    return { mode: this.mode === FilterMode.And ? FilterMode.And : null };
  }

  fromUrlParams({ mode }: { [key: string]: string | null }): void {
    if (mode?.toLowerCase() === FilterMode.And) {
      this.setMode(FilterMode.And);
    }
  }

  serializeToView() {
    return {};
  }

  deserializeFromView() {}

  serializeToBackboneFilter() {
    return { mode: this.getMode() };
  }
}
